import { GetPostsByUserIdApiResponse } from "store/userPosts/userPosts.types";
import { CreatePostData, User } from "types";
import { getApi } from "./util/getApi";

const fetchURL = process.env.REACT_APP_API_URL + "/post";

const api = getApi(fetchURL);

const commentsFetchURL = process.env.REACT_APP_API_URL;

const commentsApi = getApi(commentsFetchURL);

export const getPosts = (data: { dataPage: number }) =>
  api
    .get(`/retrieveAll`, {
      params: {
        dataPage: data.dataPage,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching posts:", error);
      throw error;
    });

export const getFeed = (
  type: "me" | "following",
  dataPage: number = 1,
  limit: number = 10
) =>
  api
    .post("/getFeed", { type, dataPage, limit })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.error("Error fetching feed:", err);
      throw err;
    });

export const getFeedByUser = (
  userId: number,
  dataPage: number = 1,
  limit: number = 10
) =>
  api
    .post("/getFeedByUser", { userId, dataPage, limit })
    .then((res) => res.data)
    .catch((err) => {
      console.error("Error fetching feed:", err);
      throw err;
    });

export const togglePostLike = (data: { postId: number; postOwnerId: number }) =>
  api
    .post(`/setPostLiked`, data)
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error toggling post like:", error);
      throw error;
    });

export const getComments = (data: {
  comment_type: string;
  object_id: number;
  page: number;
  limit: number;
}) =>
  commentsApi
    .get(`/comment/getComments`, { params: data })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching comments:", error);
      throw error;
    });

export const getReplies = (data: {
  parent_id: number;
  page: number;
  limit: number;
}) =>
  commentsApi
    .get(`/comment/getReplies`, { params: data })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching replies:", error);
      throw error;
    });

export const createComment = (
  object_id: number,
  comment_body: string,
  parent_id: number | null = null
) =>
  commentsApi
    .post(`/comment/createComment`, {
      comment_type: "POST",
      object_id,
      comment_body,
      parent_id,
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error creating comment:", error);
      throw error;
    });

export const setCommentLiked = (commentId: number, commentOwnerId: number) =>
  commentsApi
    .post(`/comment/setCommentLiked`, {
      commentId,
      commentOwnerId,
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error setting comment as liked:", error);
      throw error;
    });

export const createPost = (data: CreatePostData) => {
  api
    .post(`/insertDocument`, data)
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error creating post:", error);
      throw error;
    });
};
// post available to link to projects
export const getPostsToLink = (userId: number, page: number = 1) => {
  let data = {
    dataPage: page,
    userId: userId,
    addPost: true,
  };

  return api.post(`/retrieveForUser`, data).then((response) => response.data);
};

export const getPostsByProject = async (projectId: number) => {
  try {
    const response = await api.post("/getPostsByProject", {
      project_id: projectId,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching posts by project:", error);
    throw error;
  }
};

export const getPostsById = async (postId: number) => {
  try {
    const response = await api.post("/retrieveDocument", { id: postId });
    return response.data;
  } catch (error) {
    console.error("Error fetching posts by id:", error);
    throw error;
  }
};

export const getPostsByUserId = async (
  userId: User["id"]
): Promise<GetPostsByUserIdApiResponse["data"]> => {
  try {
    const dataPage = "1";
    const addPost = true;
    const response: GetPostsByUserIdApiResponse = await api.post(
      "/retrieveForUser",
      { dataPage, userId, addPost }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching posts by userId:", error);
    throw error;
  }
};
